import { render, staticRenderFns } from "./SaveImg.vue?vue&type=template&id=1e8e817c&scoped=true"
import script from "./SaveImg.vue?vue&type=script&lang=js"
export * from "./SaveImg.vue?vue&type=script&lang=js"
import style0 from "./SaveImg.vue?vue&type=style&index=0&id=1e8e817c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e817c",
  null
  
)

export default component.exports